import { updateKeyInStore } from 'App';
import { updateKey } from '../slice';

import { fields } from '../fields';

type UploadFields = typeof fields;

export const uploadFields: UploadFields = [
  {
    dependenciesTitle: 'U.S. Interest Income',
    name: 'usInterestIncome',
    label: 'US Interest Income',
    subLabel: () => (
      <p>Please upload form 1099-INT\nNot required if below $10</p>
    ),
    type: 'upload',
    predicate: (value) =>
      value === 'Yes - US Interest Only' ||
      value === 'Both - US & Foreign Interest',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.passiveIncome.interest.values.didReceiveAnyInterestIncomeDuringTheFilingYear',
  },
];
